module.exports = __webpack_public_path__ + "static/media/Maui2.7d43004c.webp";